import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LookupModel } from '@core/services/api.service';

export interface ReportDelayDialogData {
    reasons: LookupModel[];
    title?: string;
}

@Component({
    selector: 'app-report-delay-dialog',
    templateUrl: './report-delay-dialog.component.html',
    styleUrls: ['./report-delay-dialog.component.scss'],
})
export class ReportDelayDialogComponent {
    selectedReasonCode: number | null = null;

    constructor(
        public dialogRef: MatDialogRef<ReportDelayDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ReportDelayDialogData
    ) { }

    cancel(): void {
        this.dialogRef.close(undefined);
    }

    confirm(): void {
        if (this.selectedReasonCode == null) {
            return;
        }

        this.dialogRef.close(Number(this.selectedReasonCode));
    }
}
